if ($('.mepr-form').length) {
    let form = document.querySelector("form");
    form.addEventListener("change", (evt) => {
        let trg = evt.target,
            trg_par = trg.parentElement;
        if (trg.type === "checkbox" && trg_par && trg_par.tagName.toLowerCase() === "label") {
            let prior = form.querySelector('label.checked input[name="' + trg.name + '"]');
            trg_par.classList.toggle('checked');
        }
    }, false);
}
